import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#0a0a0a] py-20 px-4" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-br from-[#111111] to-[#1a1a2e] border border-indigo-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-2xl" data-id="element-55">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-500" data-id="element-56" />

          <div className="flex justify-center mb-6" data-id="element-57">
            <div className="bg-indigo-500/10 p-4 rounded-full" data-id="element-58">
              <ShieldCheckIcon className="w-16 h-16 text-indigo-400" data-id="element-59" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-60">
            Garantía de Satisfacción "Cero Riesgo" de 7 Días
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-61">
            Prueba el Creator OS completo. Mira los bonos, usa los prompts,
            implementa el plan de 7 días. Si sientes que no es para ti o que no
            vale 10 veces lo que pagaste, envíanos un email y te devolvemos el
            100% de tu dinero. Sin preguntas, sin vueltas.{' '}
            <strong className="text-white" data-id="element-62">
              El riesgo está todo de mi lado.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}